import { c as _c } from "react/compiler-runtime";
import { ALLOWED_MEDIA, ResponsiveImage } from '@/app/components/media/app-image';
import { SPARTAN_PRODUCT_HERO_DESKTOP_COMPOSITION_MEDIA, SPARTAN_PRODUCT_HERO_DESKTOP_IMAGE_WIDTHS, SPARTAN_PRODUCT_HERO_MOBILE_COMPOSITION_MEDIA, SPARTAN_PRODUCT_HERO_MOBILE_DPR_2_BACKGROUND_IMAGE_WIDTHS } from '@/app/lcv/components/sections/spartan/products/hero-banner/constants';
import type { SpartanProductHeroBannerMainBackgroundProps } from '@/app/lcv/components/sections/spartan/products/hero-banner/media/main-background/types';
import { SPARTAN_PRODUCT_HERO_BANNER_TRACKING } from '@/app/lcv/components/sections/spartan/products/hero-banner/tracking';
import { getSpartanProductHeroParallaxStyle } from '@/app/lcv/components/sections/spartan/products/hero-banner/utils/parallax-style';
import { getSpartanParallaxProps } from '@/app/lcv/components/sections/spartan/products/shared/product-parallax-scroll';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
export const SpartanProductHeroBannerMainBackground = t0 => {
  const $ = _c(31);
  const {
    title,
    mainBg,
    isLcp: t1,
    hasLandscapeComposition: t2,
    imageRef,
    onLoad,
    onError
  } = t0;
  const isLcp = t1 === undefined ? false : t1;
  const hasLandscapeComposition = t2 === undefined ? false : t2;
  const top = mainBg.scrollSpeed ? "calc(var(--spartan-hero-vh-unit, 1svh) * -11)" : 0;
  let t3;
  if ($[0] !== mainBg.scrollSpeed) {
    t3 = getSpartanProductHeroParallaxStyle(mainBg.scrollSpeed);
    $[0] = mainBg.scrollSpeed;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t3 || $[3] !== top) {
    t4 = {
      top,
      ...t3
    };
    $[2] = t3;
    $[3] = top;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== mainBg.scrollSpeed) {
    t5 = getSpartanParallaxProps(mainBg.scrollSpeed);
    $[5] = mainBg.scrollSpeed;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = createDataAttributes({
      test: SPARTAN_PRODUCT_HERO_BANNER_TRACKING.bg
    });
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = hasLandscapeComposition ? SPARTAN_PRODUCT_HERO_MOBILE_COMPOSITION_MEDIA : ALLOWED_MEDIA.lgDown;
  let t8;
  if ($[8] !== mainBg.mobile.src || $[9] !== t7) {
    t8 = {
      src: mainBg.mobile.src,
      sizes: "100vw",
      widths: SPARTAN_PRODUCT_HERO_MOBILE_DPR_2_BACKGROUND_IMAGE_WIDTHS,
      media: t7
    };
    $[8] = mainBg.mobile.src;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== hasLandscapeComposition) {
    t9 = hasLandscapeComposition ? SPARTAN_PRODUCT_HERO_DESKTOP_IMAGE_WIDTHS : [2048, 2560, 2880, 3360];
    $[11] = hasLandscapeComposition;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = hasLandscapeComposition ? SPARTAN_PRODUCT_HERO_DESKTOP_COMPOSITION_MEDIA : ALLOWED_MEDIA.lgUp;
  let t11;
  if ($[13] !== mainBg.desktop.src || $[14] !== t10 || $[15] !== t9) {
    t11 = {
      src: mainBg.desktop.src,
      sizes: "100vw",
      widths: t9,
      media: t10
    };
    $[13] = mainBg.desktop.src;
    $[14] = t10;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  const t12 = isLcp ? "high" : undefined;
  const t13 = isLcp ? undefined : "eager";
  let t14;
  if ($[17] !== imageRef || $[18] !== isLcp || $[19] !== onError || $[20] !== onLoad || $[21] !== t11 || $[22] !== t12 || $[23] !== t13 || $[24] !== t8 || $[25] !== title) {
    t14 = <ResponsiveImage mobileSrc={t8} desktopSrc={t11} alt={title} fill={true} objectFit="cover" preload={isLcp} fetchPriority={t12} loading={t13} testId={SPARTAN_PRODUCT_HERO_BANNER_TRACKING.bgMedia} imgRef={imageRef} onLoad={onLoad} onError={onError} />;
    $[17] = imageRef;
    $[18] = isLcp;
    $[19] = onError;
    $[20] = onLoad;
    $[21] = t11;
    $[22] = t12;
    $[23] = t13;
    $[24] = t8;
    $[25] = title;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t14 || $[28] !== t4 || $[29] !== t5) {
    t15 = <div className="absolute inset-x-0 bottom-0 z-0" style={t4} {...t5} {...t6}>{t14}</div>;
    $[27] = t14;
    $[28] = t4;
    $[29] = t5;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  return t15;
};